export const actions = {
  SET_TIMER: "SET_TIMER",
};

export const setTimer = (data) => ({
  type: actions.SET_TIMER,
  data,
});
